"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Exception = void 0;

var _ExceptionCode = require("./ExceptionCode");

var _Tools = require("../Tools");

const processErrorMessage = (message, options = []) => {
  return _Tools.StringTemplate.replace(message, {
    '%a%': (options === null || options === void 0 ? void 0 : options[0]) || '%a%',
    '%b%': (options === null || options === void 0 ? void 0 : options[1]) || '%b%',
    '%c%': (options === null || options === void 0 ? void 0 : options[2]) || '%c%'
  });
};

class Exception extends Error {
  get code() {
    return this._code;
  }

  get message() {
    return this._message;
  }

  get options() {
    return this._options;
  }

  constructor(code = 0, message = null, options = null) {
    if (!message) {
      message = processErrorMessage(_ExceptionCode.ExceptionCode.getMessage(code, _Tools.EnvironmentVariables.EASY_LANGUAGE || 'en_en'), options);
    }

    super(message);
    this._code = code;
    this._message = message;
    this._options = options;
  }

}

exports.Exception = Exception;